export const trimEndingSlash = (url: string): string => {
  return url.replace(/\/+$/, '');
};
